/* istanbul ignore file */
import { createSlice } from "@reduxjs/toolkit";
// import { msalConfig } from "../../authentication/authConfig"; // Commented out to fix import error

const initialState = {
  authenticated: false
};

export const loginSlice = createSlice({
  name: "login",
  initialState,
  reducers: {
    setLogin: (state) => {
      state.authenticated = true;
    },
    setLogout: (state, action) => {
      // state.authenticated = false;

      // // localStorage.clear();
      // // sessionStorage.clear();

      // let instance = action.payload.msalInstance.instance;
      // let { redirect } = action.payload;

      // if (instance) {
      //   const logoutRequest = {
      //     account: instance.getActiveAccount(),
      //     mainWindowRedirectUri: msalConfig.auth.redirectUri,
      //     postLogoutRedirectUri: msalConfig.auth.postLogoutRedirectUri
      //   };

      //   if (redirect) {
      //     instance.logoutRedirect(logoutRequest);
      //   } else {
      //     instance.logoutRedirect({
      //       account: instance.getActiveAccount(),
      //       onRedirectNavigate: () => {
      //         return false;
      //       }
      //     });
      //   }
      // }
      sessionStorage.removeItem("activeTime");
    }
  }
});

export const { setLogin, setLogout } = loginSlice.actions;

export default loginSlice.reducer;
